import React from "react";
import { Tab } from "@headlessui/react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import { TabItem as TabItemType } from "../types";
import { styles } from "../styles";

interface TabPanelProps<T extends TabItemType> {
  tab: TabItemType;
  isUrlBased: boolean;
  panelClassName?: string;
  headerComponent?: React.ComponentType<T>;
  title?: string;
  description?: string;
}

export const TabPanel = <T extends TabItemType>({
  tab,
  isUrlBased,
  panelClassName,
  headerComponent: HeaderComponent,
  title,
  description,
}: TabPanelProps<T>) => {
  const location = useLocation();

  return (
    <Tab.Panel className={`${styles.panels.panel} ${panelClassName || ""}`} tabIndex={-1}>
      <motion.div
        className="flex h-full min-h-0 flex-col"
        key={isUrlBased ? location.pathname : tab.id}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.2 }}
      >
        {HeaderComponent && (
          <HeaderComponent title={title || ""} description={description || ""} {...(tab as T)} />
        )}
        {isUrlBased ? <Outlet /> : tab.content}
      </motion.div>
    </Tab.Panel>
  );
};
